<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="back-btn" type="button" @click="back()" v-if="filter.redirect == 'daily'">
                            <i class="fas fa-arrow-left"></i>
                        </button>
                        Agent Report List
                    </div>
                    <div class="card-body">
                         <div class="row" v-if="filter.redirect != 'daily'">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.from"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                     <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.to"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Agent Name</th>
                                        <th colspan="3" class="text-center">Master</th>
                                        <th colspan="3" class="text-center">Agent</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">Bet</th>
                                        <th class="text-center">Commission</th>
                                        <th class="text-center">W/L</th>
                                        <th class="text-center">Bet</th>
                                        <th class="text-center">Commission</th>
                                        <th class="text-center">W/L</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td class="text-center">
                                            <a href="#" @click="toMemberReportForDaily(data)" v-if="filter.redirect == 'daily'">
                                                {{ data.agent_name }}
                                            </a>
                                            <a href="#" @click="toMemberReportForAgent(data)" v-if="filter.redirect != 'daily'">
                                                {{ data.agent_name }}
                                            </a>
                                        </td>
                                        <td class="text-center">{{ data.total_bet_amount }}</td>
                                        <td class="text-center">{{ data.total_master_commission }}</td>
                                        <td class="text-center">{{ data.total_master_win_or_lose }}</td>
                                        <td class="text-center">{{ data.total_bet_amount }}</td>
                                        <td class="text-center">{{ data.total_agent_commission }}</td>
                                        <td class="text-center">{{ data.total_agent_commission }}</td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="8"  class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import { BFormDatepicker } from 'bootstrap-vue'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'dailyReportList',
        metaInfo: {
            title: "Agent Report List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading,
            BFormDatepicker
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                userName: '',
                status: '',
                dataList: [],
                permissions: '',
                columns: {
                    "agent_name": "Agent Name",
                    "total_deposit": "Total Deposit",
                    "total_withdraw": "Total Withdraw",
                    "net_deposit": "Net Deposit"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    from: new Date().toISOString().slice(0, 10),
                    to: new Date().toISOString().slice(0, 10),
                    redirect: "",
                    rePage: "",
                    reOrderBy: "",
                    reSortKey: "",
                    reLimit: "",
                    reFrom: "",
                    reTo: "",
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
    methods: {
            ...mapActions({
                agentReportListAction: 'agentReportListAction',

            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async getPaymentMethod(){
				await this.paymentMethodAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.agentReportListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'agent-report-list', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey,
                                from: this.filter.from,
                                to: this.filter.to,
                                redirect: this.filter.redirect,
                                rePage: this.filter.rePage,
                                reOrderBy: this.filter.reOrderBy,
                                reSortKey: this.filter.reSortKey,
                                reLimit: this.filter.reLimit,
                                reFrom: this.filter.reFrom,
                                reTo: this.filter.reTo
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'agent-report-list', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at'
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            back() {
                if(this.filter.redirect == 'daily') {
                    this.$router.replace({
                        path: 'daily-report-list',
                        query: {
                            page: this.filter.rePage,
                            orderBy: this.filter.reOrderBy,
                            sortKey: this.filter.reSortKey,
                            limit: this.filter.reLimit,
                            from: this.filter.reFrom,
                            to: this.filter.reTo,
                            redirect: this.filter.redirect
                        }
                    }).catch(()=>{})
                }
            },
            toMemberReportForDaily(data) {
                this.$router.push({
                    path: 'member-report-list',
                    query: {
                        page: 1,
                        orderBy: "desc",
                        sortKey: "created_at",
                        limit: "10",
                        agent_name: data.agent_name,
                        from: this.filter.from,
                        to: this.filter.to,
                        agPage: this.filter.page,
                        agOrderBy: this.filter.orderBy,
                        agSortKey: this.filter.sortKey,
                        agLimit: this.filter.limit,
                        agFrom: this.filter.from,
                        agTo: this.filter.to,
                        redirect: 'daily',
                        rePage: this.filter.rePage,
                        reOrderBy: this.filter.reOrderBy,
                        reSortKey: this.filter.reSortKey,
                        reLimit: this.filter.reLimit,
                        reFrom: this.filter.reFrom,
                        reTo: this.filter.reTo
                    }
                }).catch(()=>{})
            },
            toMemberReportForAgent(data) {
                this.$router.push({
                    path: 'member-report-list',
                    query: {
                        page: 1,
                        orderBy: "desc",
                        sortKey: "created_at",
                        limit: "10",
                        agent_name: data.agent_name,
                        from: this.filter.from,
                        to: this.filter.to,
                        agPage: this.filter.page,
                        agOrderBy: this.filter.orderBy,
                        agSortKey: this.filter.sortKey,
                        agLimit: this.filter.limit,
                        agFrom: this.filter.from,
                        agTo: this.filter.to,
                        redirect: 'agent',
                        rePage: this.filter.rePage,
                        reOrderBy: this.filter.reOrderBy,
                        reSortKey: this.filter.reSortKey,
                        reLimit: this.filter.reLimit,
                        reFrom: this.filter.reFrom,
                        reTo: this.filter.reTo
                    }
                }).catch(()=>{})
            },
            editData(data) {
                this.id = data.id
                this.userName = data.user_name
                this.status = data.status
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        async mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.rePage = this.$route.query.rePage
            this.filter.reOrderBy = this.$route.query.reOrderBy
            this.filter.reSortKey = this.$route.query.reSortKey
            this.filter.reLimit = this.$route.query.reLimit
            this.filter.reFrom = this.$route.query.reFrom
            this.filter.reTo = this.$route.query.reTo
            if(this.$route.query.from){
                this.filter.from = this.$route.query.from
            }
            if(this.$route.query.to){
                this.filter.to = this.$route.query.to
            }
            this.filter.redirect = this.$route.query.redirect
            await this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>